@if (user$ | async; as user) {
<app-user [user]="user" />
} @else {
<a class="icon-link gap-2 link-body-emphasis text-decoration-none" [routerLink]="['/account/auth/signIn']" [queryParams]="{ continue: continueUrl || '/' }" aria-label="Sign In" i18n-aria-label>
  <fa-icon [icon]="iconUser" [size]="'xs'" />
  <small i18n>Giriş</small>
</a>
}